import { render, staticRenderFns } from "./GoalCard.vue?vue&type=template&id=daa47ac2&scoped=true&"
import script from "./GoalCard.vue?vue&type=script&lang=js&"
export * from "./GoalCard.vue?vue&type=script&lang=js&"
import style0 from "./GoalCard.vue?vue&type=style&index=0&id=daa47ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa47ac2",
  null
  
)

export default component.exports